import styled from 'styled-components';
import { Card, Divider, Flex, Heading } from '@amzn/storm-ui';

export const StyledCard = styled(Card)`
  border-top: 0.2rem solid ${({ theme }) => theme.steps.iconColor.active};
  border-radius: 0.4rem;
  margin-top: 1rem;
`;

export const HeaderText = styled(Heading)`
  font-size: 1rem;
  color: ${({ theme }) => theme.text.color.unavailable};
  margin: -1rem 0;
`;

export const CustomDivider = styled(Divider)`
  width: calc(100% + 2.5rem);
  margin-left: -1rem;
`;

export const StyledFlex = styled(Flex)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  column-gap: 1rem;
`;
